var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSendingTicket = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.632 5.692 12.978 9.65 7.324 5.692"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.285 14.738V3.43a2.26 2.26 0 0 0-2.261-2.261H3.93A2.26 2.26 0 0 0 1.67 3.43v11.308A2.26 2.26 0 0 0 3.93 17h18.093a2.26 2.26 0 0 0 2.261-2.262"
})));
export default SvgSendingTicket;